import React from 'react';
import PropTypes from 'prop-types';
import SelectNestedMenuDialog from './common/SelectNestedMenuDialog';
import { departmentNestedMenu } from '../../../../constants/SidebarValues';

class SelectDepartmentDialog extends React.Component {
  render() {
    return (
      <SelectNestedMenuDialog
        isOpen={this.props.isOpen}
        toggleDialog={this.props.toggleDialog}
        set={this.props.set}
        save={this.props.save}
        title="部門を選択"
        nestedMenu={departmentNestedMenu}
        contextData={{
          shouldShowLabel: (item) => this.props.researchedTelHasDepartmentKeys.includes(item.value),
          labelText: "部門電話 NEW"
        }}
      />
    );
  }
}

SelectDepartmentDialog.defaultProps = {
  researchedTelHasDepartmentKeys: [],
};

SelectDepartmentDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  set: PropTypes.object.isRequired,
  researchedTelHasDepartmentKeys: PropTypes.array,
};

export default SelectDepartmentDialog;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectDepartmentDialog.jsx